import { allMeanings } from "@api/Vocabulary";
import { IWord } from "interfaces/DefaultQuizzes/DefaultQuizzes.interface";

interface Word {
	palabra_opcional: string | null;
	idioma: { id: number | string } | number | string;
	advertencia: string;
	significado: string | string[];
	paper: number | string;
	id_significado: number[];
	subcategories_ids?: number[];
	subcategories_ids_del: number[];
}
export const processWord = async (word: Word): Promise<IWord> => {
	if (!word.palabra_opcional) {
		word.palabra_opcional = null;
	}

	if ((word.idioma as any).id) {
		word.idioma = (word.idioma as any).id;
	}
	if (!word.advertencia) {
		word.advertencia = "";
	}
	word.idioma = parseInt(word.idioma as string);
	word.paper = parseInt(word.paper as string);

	word.id_significado = [];
	const significadoArr = Array.isArray(word.significado)
		? word.significado
				.map((s) => (typeof s === "string" ? s.trim() : ""))
				.filter((s) => s.length > 0)
		: word.significado
				.split("|")
				.map((s) => s.trim())
				.filter((s) => s.length > 0);

	const meaningPromises = significadoArr.map(async (meaning) => {
		const response = await allMeanings({
			search: meaning,
			language: String(word.idioma),
			limit: 5,
		});
		const match = response?.meanings?.find(
			(item) => item.spanish_word?.trim().toLowerCase() === meaning.toLowerCase()
		);
		return match?.id ?? meaning;
	});

	const meaningIds = await Promise.all(meaningPromises);
	word.id_significado.push(...meaningIds);

	if (!("subcategories_ids" in word)) {
		word.subcategories_ids = [];
	}
	if (Array.isArray(word.subcategories_ids)) {
		word.subcategories_ids = word.subcategories_ids.map((value: any) => Number(value));
	}
	if (Array.isArray(word.subcategories_ids_del)) {
		word.subcategories_ids_del = word.subcategories_ids_del.map((value: any) => Number(value));
	}
	return word as IWord;
};

export const processMeanings = async (meanings: string[] | string, languageId: number) => {
	const significadoArr = Array.isArray(meanings)
		? meanings.map((s) => (typeof s === "string" ? s.trim() : "")).filter((s) => s.length > 0)
		: meanings
				.split("|")
				.map((s) => s.trim())
				.filter((s) => s.length > 0);

	const meaningPromises = significadoArr.map(async (meaning) => {
		const response = await allMeanings({
			search: meaning,
			language: String(languageId),
			limit: 5,
		});
		const match = response?.meanings?.find(
			(item) => item.spanish_word?.trim().toLowerCase() === meaning.toLowerCase()
		);
		return match?.id ?? meaning;
	});

	const meaningIds = await Promise.all(meaningPromises);
	return meaningIds;
};
